import { TimeseriesChartItem } from 'shared/components/TimeseriesChart/types';

const timeMapper: { [key: string]: number } = {
  Y: 360,
  M: 30,
  D: 1,
};

export const sortByPeriodString = (
  a: TimeseriesChartItem,
  b: TimeseriesChartItem
): number => {
  const { name: nameA } = a;
  const { name: nameB } = b;
  const getNumberA = parseFloat(nameA.slice(0, nameA.length - 1));
  const getNumberB = parseFloat(nameB.slice(0, nameB.length - 1));
  const getTimeLetterA = nameA.slice(nameA.length - 1).toLocaleUpperCase();
  const getTimeLetterB = nameB.slice(nameB.length - 1).toLocaleUpperCase();

  return (
    getNumberA * timeMapper[getTimeLetterA] -
    getNumberB * timeMapper[getTimeLetterB]
  );
};
